import { SearchNormal } from "iconsax-react";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const SearchInput = ({
  value,
  onChange,
  placeholder = "Filter by ID",
}: SearchInputProps) => (
  <div className="flex min-w-[149px] relative">
    <SearchNormal
      variant="Bold"
      color="#FEFEFE"
      className="absolute left-1.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-dark-80"
    />
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full pl-6 pr-1.5 py-1 bg-dark-10 rounded-[5px] text-dark-text placeholder-dark-70 focus:outline-none focus:ring-2 focus:ring-dark-text/50 focus:border-dark-text"
    />
  </div>
);
